import Switch from "@mui/material/Switch";

export default function StatusSwitch(props) {
  const { handleChange, checked } = props;
  return (
    <Switch
      value="checkedA"
      checked={checked}
      onChange={handleChange}
      inputProps={{ "aria-label": "secondary checkbox" }}
    />
  );
}
